<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        class="screenInput"
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        ><el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入标题"
      ></el-input>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-top: 10px;margin-bottom: 10px;"
      v-if="roles.includes('/mall/product_add')"
      >添加</el-button
    >
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标签标题" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="标签序号" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.sort }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="操作"
        fixed="right"
        min-width="210"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row.id)"
            v-if="roles.includes('/mall/product_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row.id)"
            v-if="roles.includes('/mall/product_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/mall/product_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="120px"
        class="demo-shopForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="shopForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型名称" prop="title">
          <el-input
            class="w4"
            :disabled="czType == 'see'"
            v-model="shopForm.title"
            placeholder="请输入类型名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="sort">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            v-model="shopForm.sort"
            placeholder="请输入序号"
            type="number"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('shopForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('shopForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="drawer = false"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
import { openPark, adminUser } from "@/api/index";
import { mapGetters } from "vuex";
import {
  productTypeAdd,
  productTypeDel,
  productTypeEdit,
  productTypeInfo,
  productTypeLists,
} from "@/api/shop";
import { getToken } from "@/utils/auth";
import Editor from "@/components/Editor";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      listLoading: false,
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
      },
      parkList: [],
      list: [],
      total: 0,
      drawerTitle: "",
      czType: "",
      drawer: false,
      shopForm: {},
      imageList: [],
      bannerList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请输入类型名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入序号", trigger: "blur" }],
      },
    };
  },
  created() {
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 查看按钮
    handleInfo(id){
      this.drawerTitle = "查看";
      this.czType = "see";
      this.getPark();
      this.getInfo(id)
    },
    // 编辑按钮
    handleEdit(id){
      this.drawerTitle = "编辑";
      this.czType = "edit";
      this.getPark();
      this.getInfo(id)
    },
    getInfo(id){
      var that = this
      productTypeInfo({id:id}).then(res=>{
        console.log(res)
        that.shopForm = {
          id:res.data.info.id,
        title:res.data.info.title,
        park_id:res.data.info.park_id,
        sort:res.data.info.sort,
      };
      that.drawer = true;
      })
    },
    // 编辑
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.shopForm);
          productTypeEdit(that.shopForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 添加
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.shopForm);
          productTypeAdd(that.shopForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 添加商品
    addMenu() {
      this.drawerTitle = "添加";
      this.czType = "add";
      this.shopForm = {
        title: "",
        park_id: "",
        sort: 0,
      };
      if (this.userInfo.park_id !== 0) {
        this.shopForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.shopForm.clearValidate();
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          productTypeDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.shopForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 分页 end
    // 重置
    reset() {
      this.screen = {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取数据
    fetchData() {
      this.listLoading = true;
      productTypeLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.w4 {
  width: 40%;
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
